import React, { Component } from "react";
import RagEvidenceCard from "./RagEvidenceCard";

// The server owns the answer: each claim's text, grouping and citations are rendered exactly as returned,
// for every question and every kind of document. Nothing here knows a category or a question.
export default class RagAnswer extends Component {
  state = { expandedSources: {} };
  toggleSource = key => this.setState(state => ({
    expandedSources: { ...state.expandedSources, [key]: !state.expandedSources[key] },
  }));

  render() {
    const { response, evidence, getDocument, onView } = this.props;
    const claims = response.claims;
    const sources = new Map();
    response.claims.forEach(claim => claim.citations.forEach(citation => {
      const key = `${citation.templateId}:${citation.fileId}`;
      if (!sources.has(key)) sources.set(key, { key, citations: [], number: sources.size + 1 });
      const group = sources.get(key);
      const identity = JSON.stringify([citation.evidenceId, citation.candidateOrdinal, citation.chunkOrdinal, citation.quote, citation.supportingSpan]);
      if (!group.citations.some(c => c.identity === identity)) group.citations.push({ identity, citation });
    }));
    return <section className="chat-search-grounded-answer" aria-labelledby="chatSearchAnswerTitle">
      <div className="chat-search-answer-heading"><h4 id="chatSearchAnswerTitle">
        {/* Excerpts the server could not verify as an answer are never called verified. */}
        {response.verified === false ? "Passages that mention this" : "Answer from verified evidence"}
      </h4></div>
      {response.verified === false && <p className="chat-search-answer-note">
        The assistant could not confirm a single answer from these passages. Open a source to read it in full.
      </p>}
      <ul className="chat-search-answer-claims">{claims.map((claim, index) => (
        <li className="chat-search-answer-claim" key={index}>
          <p className="chat-search-answer-text">
            {claim.documentLabel && <strong>{claim.documentLabel}{" — "}</strong>}{claim.text}
          </p>
            {[...new Set(claim.citations.map(c => `${c.templateId}:${c.fileId}`))].map(key =>
              <a className="answer-source-reference" key={key} href={`#answer-source-${sources.get(key).number}`}
                aria-label={`Source ${sources.get(key).number}`}> [{sources.get(key).number}]</a>)}
        </li>
      ))}</ul>
      <div className="chat-search-answer-sources">{[...sources.values()].map(group => {
        const first = group.citations[0].citation;
        const resolved = getDocument(first);
        const title = first.documentLabel || (resolved.document && resolved.document.fileName) || "Document";
        const sourceId = `answer-source-${group.number}`;
        const expanded = !!this.state.expandedSources[group.key];
        return <div className="chat-search-answer-source" key={group.key} id={sourceId}>
          <button type="button" className="chat-search-citation-button" aria-expanded={expanded}
            aria-controls={sourceId + "-evidence"} onClick={() => this.toggleSource(group.key)}>
            Source: {title} [{group.number}]
          </button>
          {expanded && <div id={sourceId + "-evidence"}>{group.citations.map(({ citation, identity }, index) => {
            const source = evidence.find(item => item.templateId === citation.templateId && item.fileId === citation.fileId &&
              Number.isInteger(citation.candidateOrdinal) && citation.candidateOrdinal > 0 &&
              item.candidateOrdinal === citation.candidateOrdinal &&
              (citation.chunkOrdinal == null || item.chunkOrdinal === citation.chunkOrdinal));
            const pages = Array.isArray(citation.pageNumbers) ? [...new Set(citation.pageNumbers.filter(p => Number.isInteger(p) && p > 0))] : [];
            const { document } = getDocument({ ...citation, fileName: title });
            return <RagEvidenceCard key={identity} evidence={source || { evidenceText: citation.quote,
              displayExcerpt: citation.supportingSpan, sourcePageNumbers: pages, pageRange: citation.pageRange }} title={title} document={document}
              pageCount={citation.viewerPageCount} passageId={`${sourceId}-passage-${index}`} onView={onView} />;
          })}</div>}
        </div>;
      })}</div>
    </section>;
  }
}

